// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'E:/zhipu/知因-aminer/zhiyin-v2/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/Loading';

export function getRoutes() {
  const routes = [
  {
    "exact": false,
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index'), loading: LoadingComponent}),
    "name": "home",
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home__index' */'@/pages/home/index'), loading: LoadingComponent}),
        "title": "知因分析-开源科技情报智能服务平台",
        "exact": true
      },
      {
        "path": "/aminerandzhiyin",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aminerandzhiyin__index' */'@/pages/aminerandzhiyin/index'), loading: LoadingComponent}),
        "title": "知因分析-开源科技情报智能服务平台",
        "exact": true
      },
      {
        "path": "/ana",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__analysis__index' */'@/pages/analysis/index'), loading: LoadingComponent}),
        "title": "技术分析页",
        "exact": true
      },
      {
        "path": "/list",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__list__index' */'@/pages/list/index'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/dynamic",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dynamic' */'@/pages/dynamic'), loading: LoadingComponent}),
        "title": "产业资讯",
        "exact": true
      },
      {
        "path": "/user",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__index' */'@/pages/user/index'), loading: LoadingComponent}),
        "title": "个人中心",
        "routes": [
          {
            "path": "/user/info",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__info__index' */'@/pages/user/info/index'), loading: LoadingComponent}),
            "title": "我的信息-个人中心",
            "exact": true
          },
          {
            "path": "/user/record",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__record__index' */'@/pages/user/record/index'), loading: LoadingComponent}),
            "title": "检索记录-个人中心",
            "exact": true
          },
          {
            "path": "/user/report",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__report__index' */'@/pages/user/report/index'), loading: LoadingComponent}),
            "title": "分析报告-个人中心",
            "exact": true
          },
          {
            "path": "/user/order",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__order__index' */'@/pages/user/order/index'), loading: LoadingComponent}),
            "title": "我的订单-个人中心",
            "exact": true
          },
          {
            "path": "/user/org",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__org__index' */'@/pages/user/org/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/pages/user/wrappers/auth'), loading: LoadingComponent})],
            "title": "机构信息-个人中心",
            "exact": true
          },
          {
            "path": "/user/member",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__member__index' */'@/pages/user/member/index'), loading: LoadingComponent}),
            "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/pages/user/wrappers/auth'), loading: LoadingComponent})],
            "title": "成员管理-个人中心",
            "exact": true
          },
          {
            "path": "/user/*",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__404' */'@/pages/user/404'), loading: LoadingComponent}),
            "title": "404",
            "exact": true
          }
        ]
      },
      {
        "path": "/vip",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__vip__index' */'@/pages/vip/index'), loading: LoadingComponent}),
        "title": "开通会员",
        "exact": true
      },
      {
        "path": "/advancedsearch",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__advancedsearch__index' */'@/pages/advancedsearch/index'), loading: LoadingComponent}),
        "title": "高级检索",
        "exact": true
      },
      {
        "path": "/aisearch",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AiSearch__index' */'@/pages/AiSearch/index'), loading: LoadingComponent}),
        "title": "AI生成检索式",
        "exact": true
      },
      {
        "path": "/instructions",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__instructions' */'@/pages/instructions'), loading: LoadingComponent}),
        "title": "使用说明",
        "exact": true
      },
      {
        "path": "/techtree",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__techtree' */'@/pages/techtree'), loading: LoadingComponent}),
        "title": "技术树",
        "exact": true
      },
      {
        "path": "/aisummary",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AISummary' */'@/pages/AISummary'), loading: LoadingComponent}),
        "title": "AI综述",
        "exact": true
      },
      {
        "path": "/aisummary/:id",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AISummary' */'@/pages/AISummary'), loading: LoadingComponent}),
        "title": "AI综述",
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
